import React, { useEffect, useState } from 'react';
import { Box, CircularProgress } from '@material-ui/core';
import api from 'src/api/api';
import { HEADERS } from 'src/constants/headers';
import { EmptyCalls } from './EmptyCalls';
import { CallsList } from './CallsList';

export const CallsView = ({ onClose }: { onClose: () => void }) => {
    const [callsToDisplay, setCallsToDisplay] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let mounted = true;

        api.post('/calls', { page: 1, limit: 50 }, HEADERS())
            .then(({ data }) => {
                if (mounted) setCallsToDisplay(data.data || []);
            })
            .catch(() => {
                if (mounted) setCallsToDisplay([]);
            })
            .finally(() => {
                if (mounted) setLoading(false);
            });

        return () => {
            mounted = false;
        };
    }, []);

    return (
        <Box
            style={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: 'calc(100vh - 80px)',
                flex: 1,
                position: 'relative',
                overflow: 'hidden',
            }}
        >
            {loading && (
                <Box display="flex" flex={1} alignItems="center" justifyContent="center">
                    <CircularProgress />
                </Box>
            )}

            {!loading && callsToDisplay.length === 0 && <EmptyCalls />}

            {!loading && callsToDisplay.length > 0 && (
                <CallsList onClose={onClose} calls={callsToDisplay} />
            )}
        </Box>
    );
};
